import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import * as Styled from './PhoneField.styles';
import InputMask from 'react-input-mask';

export default function PhoneField({
  title,
  disabled,
  value,
  width,
  height,
  margin,
  required,
  name,
  control,
  error,
}) {
  const isRequired = required !== undefined ? required : true;
  return (
    <Styled.Container width={width} height={height} margin={margin}>
      <Styled.Title>{title}</Styled.Title>
      <Controller
        name={name}
        control={control}
        defaultValue={value}
        render={({ field }) => (
          <InputMask
            mask="(99)99999-9999"
            maskChar=""
            value={value}
            {...field}
            disabled={disabled}
          >
            {(inputProps) => (
              <Styled.Input
                width={width}
                height={height}
                defaultValue={value}
                required={isRequired}
                {...inputProps}
                error={error}
                disabled={disabled}
              />
            )}
          </InputMask>
        )}
      ></Controller>
    </Styled.Container>
  );
}

PhoneField.defaultValue = {
  error: false,
};
PhoneField.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  error: PropTypes.bool,
  control: PropTypes.any,
  field: PropTypes.any,
};
